import { render, staticRenderFns } from "./ConfirmacaoModal.vue?vue&type=template&id=6261cbee&scoped=true"
import script from "./ConfirmacaoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoModal.vue?vue&type=style&index=0&id=6261cbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6261cbee",
  null
  
)

export default component.exports